import React from 'react';

export default function Footer() {
  return (
    <footer
      className="main-footer"
      style={{
        background: "linear-gradient(90deg, #bd6106, #1e293b)", // Adjusted to match your header orange
        color: "#e2e8f0",
        padding: "12px 20px",
        fontSize: "13px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <div className="footer-container">
        {/* LEFT: Main Branding */}
        <div className="footer-left">
          <strong>Matoshri Infra Pvt Ltd Dharashiv.</strong>
          <span className="copyright-year"> © 2026-2027</span>
        </div>

        {/* RIGHT: Version Info */}
        <div className="footer-right">
          <span>Version <b>2.1.0</b>, Developed by Bluevieprs Technology.</span>
        </div>
      </div>

      <style>{`
        .footer-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
        }

        @media (max-width: 768px) {
          .footer-container {
            flex-direction: column;
            text-align: center;
            gap: 5px;
          }
          .main-footer {
            padding: 15px 10px;
          }
          .copyright-year {
            display: block;
            font-size: 11px;
            color: #94a3b8;
          }
        }
      `}</style>
    </footer>
  );
}